import React from "react";

function SchedaProdotto(props) {
    //console.log(props);
    if (props.prodotto !== "no data") {
        //console.log(props.prodotto[0])

        const prodottoSelezionato = props.prodotto;
        const language = props.lang;
        const htmlDisplay = props.html

        /* if (props.prodotto[0].codiceVS) {
            prodottoSelezionato = props.prodotto[0];
        } else {
            prodottoSelezionato = props.prodotto;
        } */



        return (
            <div className="">
                <h1 className="pb2 bb bordoColAlt">{language}</h1>
                { !htmlDisplay && prodottoSelezionato?.descrizioniSuPS?.titolo?.[language] && <p className="pb2 bb bordoColAlt" dangerouslySetInnerHTML={{ __html: prodottoSelezionato.descrizioniSuPS.titolo[language] }}></p>}
                { !htmlDisplay && prodottoSelezionato?.descrizioniSuPS?.descBreve?.[language] && <p className="pb2 bb bordoColAlt" dangerouslySetInnerHTML={{ __html: prodottoSelezionato.descrizioniSuPS.descBreve[language] }}></p>}
                { !htmlDisplay && prodottoSelezionato?.descrizioniSuPS?.descLunga?.[language] && <p className="pb2 bb bordoColAlt" dangerouslySetInnerHTML={{ __html: prodottoSelezionato.descrizioniSuPS.descLunga[language] }}></p>}
                { !htmlDisplay && prodottoSelezionato?._id && <p className="pb2 bb bordoColAlt" dangerouslySetInnerHTML={{ __html: prodottoSelezionato._id }}></p>}
                { htmlDisplay && prodottoSelezionato?.descrizioniSuPS?.titolo?.[language] && <p className="pb2 bb bordoColAlt"> { prodottoSelezionato.descrizioniSuPS.titolo[language] }</p>}
                { htmlDisplay && prodottoSelezionato?.descrizioniSuPS?.descBreve?.[language] && <p className="pb2 bb bordoColAlt"> { prodottoSelezionato.descrizioniSuPS.descBreve[language] }</p>}
                { htmlDisplay && prodottoSelezionato?.descrizioniSuPS?.descLunga?.[language] && <p> {prodottoSelezionato.descrizioniSuPS.descLunga[language] }</p>}
            </div>
        );
    } else {
        return (
            <p>Nessun prodotto selezionato</p>
        );
    }

}

export default SchedaProdotto;